import { createAction } from "@reduxjs/toolkit";
import { CUSTOMER_CASHIER_FEATURE_KEY } from "./shared-customer-cashier-feature-keys.js";
const toggleCashierActiveWithdrawals = createAction(`${CUSTOMER_CASHIER_FEATURE_KEY}/toggleCashierActiveWithdrawals`);
export {
  toggleCashierActiveWithdrawals
};
